import React from 'react';
import { Link } from 'react-router-dom';
import MuiTypography from '@material-ui/core/Typography';
import MuiBox from '@material-ui/core/Box';
import MuiButton from '@material-ui/core/Button';
import Decimal from 'decimal.js';

import { formatDate, formatCurrency } from '../RecoupAccounts';
export default function Sidebar({ account }) {
  const formattedOpenDate = formatDate(new Date(account.open_date).getTime(), true);
  const spent = account?.spent ?? 0;
  const recouped = account?.recouped ?? 0;
  const committed = account?.committed_usd ?? 0;
  const balanceRemaining = Decimal.add(committed, spent).toNumber();

  return (
    <MuiBox pl={1}>
      <MuiBox mt={1}>
        <MuiTypography variant="caption">Total Committed</MuiTypography>
        <MuiTypography variant="h5" style={{ fontWeight: 'bold' }}>
          {formatCurrency(account.committed_usd)}
        </MuiTypography>
      </MuiBox>
      <MuiBox mt={1}>
        <MuiTypography variant="caption">Spent</MuiTypography>
        <MuiTypography variant="h5" style={{ fontWeight: 'bold' }}>
          {formatCurrency(Math.abs(spent))}
        </MuiTypography>
      </MuiBox>
      <MuiBox mt={1}>
        <MuiTypography variant="caption">Remaining Budget</MuiTypography>
        <MuiTypography variant="h5" style={{ fontWeight: 'bold', color: balanceRemaining > 0 ? 'inherit' : 'red' }}>
          {formatCurrency(balanceRemaining)}
        </MuiTypography>
      </MuiBox>
      <MuiBox mt={1}>
        <MuiTypography variant="caption">Recouped</MuiTypography>
        <MuiTypography variant="h5" style={{ color: 'green', fontWeight: 'bold' }}>
          {formatCurrency(recouped)}
        </MuiTypography>
      </MuiBox>
      <MuiBox mt={1}>
        <MuiTypography variant="caption">Estimated Recoupable</MuiTypography>
        <MuiTypography variant="h5" style={{ fontWeight: 'bold' }}>
          {formatCurrency(account.estimated_recoupable_usd)}
        </MuiTypography>
      </MuiBox>
      <MuiBox mt={1}>
        <MuiTypography variant="caption">Effective date</MuiTypography>
        <MuiTypography variant="h5">{formattedOpenDate}</MuiTypography>
      </MuiBox>
      <MuiBox mt={1}>
        <Link style={{ textDecoration: 'none' }} to={`/recoupment-account/edit/${account.id}`}>
          <MuiButton variant="contained">Edit Account</MuiButton>
        </Link>
      </MuiBox>
    </MuiBox>
  );
}
